import React from "react"
import styled from '~/ui/styled'
import { MessageProps } from "./message.props"
import { observer } from "mobx-react-lite"
import MessageSent from "./message-sent"
import MessageReceived from "./message-received"

const Text = styled.Text<{ byMe: boolean; color?: string }>`
  display: inline;
  font-size: ${({ theme }) => theme.fontSizes.lg};
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: break-word;
  color: ${({ theme, byMe, color }) =>
    color || (byMe ? theme.colors.textLight : theme.colors.text)};
`

// 文本消息
export const TextMessage: React.FC<MessageProps & { content?: string }> = observer(
  ({ message, content, color }) => {
    return (
      <Text byMe={message.byMe} color={color}>
        {content || message.content}
      </Text>
    )
  },
)

export const WrappedTextMessage: React.FC<MessageProps & { content?: string }> = observer(
  (props) => {
    return props.message.byMe ? (
      <MessageSent {...props} Component={TextMessage} />
    ) : (
      <MessageReceived {...props} Component={TextMessage} />
    )
  },
)
export default WrappedTextMessage
